'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('./../../../external/@babel/runtime/helpers/esm/extends.js');
var objectWithoutProperties = require('./../../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../../external/classnames/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["className", "sub", "tag"];
var CardTitle = function CardTitle(props) {
  var className = props.className,
    sub = props.sub,
    Tag = props.tag,
    attributes = objectWithoutProperties.default(props, _excluded);
  var classes = index.default(sub ? 'card-subtitle' : 'lanl-card-title', className);
  return /*#__PURE__*/React__default.default.createElement(Tag, _extends.default({
    "data-testid": "card-title"
  }, attributes, {
    className: classes
  }));
};
CardTitle.propTypes = {
  className: PropTypes__default.default.string,
  sub: PropTypes__default.default.bool,
  tag: PropTypes__default.default.string
};
CardTitle.defaultProps = {
  tag: 'h3',
  sub: false
};

exports.CardTitle = CardTitle;
exports.default = CardTitle;
//# sourceMappingURL=CardTitle.js.map
